import { releaseNoteApi } from 'features/releaseNote/api';
import type { RootState } from 'store';

export const selectLatestReleaseNote = (state: RootState) => releaseNoteApi.endpoints.getLatestReleaseNote.select()(state)?.data;
